export const INITIAL_TOP_POSITION = -100
export const INITIAL_LEFT_POSITION = -60
export const MIN_WIDTH = 350
export const ROW_WIDTH = 140
export const COMPRESSED_ROW_WIDTH = 90
export const MAX_ROWS = 13
